import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "../../styles/CCInstantPay.css";
import Call_Api from "../../Common/Handileapi/Call_api";
import { setDetailsToSend } from "../../redux/slice/detailsToSendSlice";
import { path } from "../../routes/Paths";
import Cookies from "js-cookie";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";

const CCInstantPay = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const doubleTap = useRef(false);
  const token = Cookies.get("token");

  const detailsToSend = useSelector((state) => state?.details?.details || {});
  console.log("detailsToSend in instant pay ====>>>", detailsToSend);
  const userDetails = useSelector((state) => state?.user?.user || {});

  const [cardValidatorResp, setCardValidatorResp] = useState({});
  const [detailsError, setDetailsError] = useState("");
  const [ipAddress, setIpAddress] = useState("");
  const [creditCardError, setCreditCardError] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [creditLengthError, setCreditLengthError] = useState("");
  const [cardError, setCardError] = useState("");

  const creditCardRef = useRef(null);
  const mobileRef = useRef(null);
  const amountRef = useRef(null);

  const formatOperatorName = (name) =>
    name?.length > 13 ? `${name.substring(0, 13)}...` : name;

  const operatorName = detailsToSend
    ? `${formatOperatorName(detailsToSend.serviceName)} - ${formatOperatorName(
        detailsToSend?.billerName
      )}`
    : "";

  const CC_REGEX = /^[0-9]{16}$/;
  const MOBILE_REGEX = /^[6-9][0-9]{9}$/;
  const AMOUNT_REGEX = /^[0-9]+$/;

  const amount = Number(detailsToSend?.actualAmount || 0);

  const isValidCC = CC_REGEX.test(detailsToSend?.creditCardNumber || "");
  const isValidMobile = MOBILE_REGEX.test(
    detailsToSend?.customerMobileNumber || ""
  );
  const isValidAmount =
    AMOUNT_REGEX.test(detailsToSend?.actualAmount || "") && amount > 0;
  const isValidLimitAmount = amount >= 1 && amount <= 200000;

  const isFormValid =
    isValidCC && isValidMobile && isValidAmount && isValidLimitAmount;

  const handleContinue = async () => {
    if (doubleTap.current) return;
    doubleTap.current = true;

    if (!isFormValid) {
      setDetailsError(
        `Check the Details once or chek limit, it should be 1 to 2,00,000`
      );
      return;
    }
    console.log("cardValidatorResp ====>>", cardValidatorResp)
    try {
      const amount = Number(detailsToSend?.actualAmount || 0);
      const data = {
        body: detailsToSend,
        binResponse: cardValidatorResp?.response,
      };

      const resp = await Call_Api(
        path.VALIDATE_CARD_INSTANTPAY,
        "POST",
        data,
        token
      );

      console.log("resp in instant pay validate ===>>>", resp);
      const dtaBack = resp?.response?.message;
      if (!resp?.response?.success) {
        if (dtaBack?.toLowerCase() == "invalid request payload") {
          setCreditCardError("Invalid creditcard details");
          return;
        } else {
          setCreditCardError(resp?.response?.message);
          return;
        }
      }

      if (resp?.success) {
        const chargeData = await fetchWalletCharges(amount);
        if (!chargeData) return;

        console.log(
          "chargeData cardValidatorResp in ccInstantPay====>>",
          chargeData,
          cardValidatorResp
        );
        dispatch(
          setDetailsToSend({
            ...detailsToSend,
            payOutFee: chargeData.payOutFee,
            payOutPercentage: chargeData.payOutPercentage,
            payOutChargedAmount: chargeData.fee,
            chargedAmount: chargeData.fee,
            totalAmount: chargeData.totalAmount,
            amount: chargeData.totalAmount,
            billType: "billPayRequest",
            mobileNumber: userDetails?.mobileNumber,
            bbpsGateWay: detailsToSend?.payOption,
            walletAmount: Number(userDetails?.walletBalance),
            walletPayOutPercentage: chargeData.payOutPercentage,
            walletPayOutFee: chargeData.payOutFee,
            ip: ipAddress,
          })
        );

        navigate("/PaymentMethod", {
          state: {
            Selectedoperator: detailsToSend?.operator,
            walletballance: Number(userDetails?.walletBalance),
            ntarTransactionId: detailsToSend?.ntarTransactionId,
          },
        });
      }
    } catch (err) {
      console.error("Instant Pay error", err);
    } finally {
      doubleTap.current = false;
    }
  };

  const fetchWalletCharges = async (amount) => {
    const details = {
      paymentMethod: "Credit Card",
      paymentMode: "Credit Card",
      paymentType: "Credit Card",
      serviceName: "PayOut",
    };

    const res = await Call_Api(
      path.BBPS_GET_WALLET_PAYOUT_CHARGES,
      "POST",
      details,
      token
    );

    if (res?.response?.length > 0) {
      const { payOutFee, payOutPercentage } = res.response[0];

      const fee = payOutFee
        ? Number(payOutFee)
        : (Number(payOutPercentage || 0) / 100) * amount;

      return {
        payOutFee,
        payOutPercentage,
        fee,
        totalAmount: amount + fee,
      };
    }
    return null;
  };

  useEffect(() => {
    sessionStorage.setItem("CC_INSTANT_PAY_ACTIVE", "true");
  }, []);

  useEffect(() => {
    const card = detailsToSend?.creditCardNumber;
    if (!card || card.length !== 16) return;

    const timer = setTimeout(async () => {
      try {
        const response = await Call_Api(
          path.VALIDATE_CREDIT_CARDNUMBER,
          "POST",
          {
            ...detailsToSend,
            card_number: card,
            skipValidation: true,
          },
          token,
          dispatch
        );
        console.log("resp in validate card in instant pay", response);
        if (response?.response?.is_valid && response?.success) {
          setCardValidatorResp(response);
        } else {
          setCardValidatorResp({});
          setCardError(response?.message || response?.response?.message);
        }
      } catch (e) {
        console.error("Card validation failed", e);
      }
    }, 200);

    return () => clearTimeout(timer);
  }, [detailsToSend?.creditCardNumber]);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue =
        "If you refresh the page, you will have to start from the beginning.";
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    const wasActive = sessionStorage.getItem("CC_INSTANT_PAY_ACTIVE");

    if (
      wasActive &&
      !detailsToSend?.serviceName &&
      !detailsToSend?.creditCardNumber
    ) {
      sessionStorage.removeItem("CC_INSTANT_PAY_ACTIVE");

      navigate("/bbps/Credit Card", {
        replace: true,
        state: {
          record: "Credit Card",
        },
      });
    }
  }, []);

  useEffect(() => {
    fetch("https://api.ipify.org?format=json")
      .then((res) => res.json())
      .then((data) => setIpAddress(data.ip));

    if (detailsToSend?.isEditable && !detailsToSend?.creditCardNumber) {
      dispatch(
        setDetailsToSend({
          ...detailsToSend,
          creditCardNumber: "",
          customerMobileNumber: "",
        })
      );
    }
  }, []);

  return (
    <div className="cc-wrapper">
      <div className="cc-header">
        <KeyboardBackspaceIcon
          className="back-icon"
          fontSize="large"
          onClick={() => {
            dispatch(
              setDetailsToSend({
                serviceName: "",
                subService: "",
              })
            );
            navigate("/bbps/Credit Card", { state: { record: "Credit Card" } });
          }}
        />
      </div>
      <div className="cc-card">
        <h3>{operatorName}</h3>

        <div className="provider">
          <img src={detailsToSend?.billerLogo} alt="logo" />
          <strong>{detailsToSend?.billerName}</strong>
        </div>

        <div className="form">
          <label style={{ textAlign: "left" }}>Credit Card Number *</label>
          <input
            ref={creditCardRef}
            maxLength="16"
            placeholder="Enter Credit Card Number"
            readOnly={!detailsToSend?.isEditable}
            value={detailsToSend?.creditCardNumber || ""}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, "");
              setCardError("");
              setCreditCardError("");
              dispatch(
                setDetailsToSend({
                  ...detailsToSend,
                  creditCardNumber: value,
                })
              );

              // error handling
              if (value.length > 0 && value.length < 16) {
                setCreditLengthError("Credit Card number must be 16 digits");
              } else {
                setCreditLengthError("");
              }

              // auto move to mobile
              if (value.length === 16) {
                mobileRef.current?.focus();
              }
            }}
          />
          <p style={{ color: "red" }}>{creditLengthError}</p>

          <label style={{ textAlign: "left" }}>
            Registered Mobile Number *
          </label>
          <input
            ref={mobileRef}
            maxLength="10"
            placeholder="Enter Mobile Number"
            readOnly={!detailsToSend?.isEditable}
            value={detailsToSend?.customerMobileNumber || ""}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, "");
              setCreditCardError("")
              dispatch(
                setDetailsToSend({
                  ...detailsToSend,
                  customerMobileNumber: value,
                })
              );

              // error handling
              if (value.length > 0 && value.length < 10) {
                setMobileError("Mobile number must be 10 digits");
              } else {
                setMobileError("");
              }

              // auto move to amount
              if (value.length === 10) {
                amountRef.current?.focus();
              }
            }}
          />
          <p style={{ color: "red" }}>{mobileError}</p>

          <label style={{ textAlign: "left" }}>Amount *</label>
          <input
            value={detailsToSend?.actualAmount || ""}
            placeholder="Enter Amount"
            ref={amountRef}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, "");

              dispatch(
                setDetailsToSend({
                  ...detailsToSend,
                  actualAmount: value,
                })
              );
            }}
          />
        </div>
        {Number(detailsToSend?.actualAmount) > 200000 ||
        Number(detailsToSend?.actualAmount) < 1 ? (
          <p style={{ color: "red" }}>You Can Enter From 1 to 2,00,000 only</p>
        ) : (
          ""
        )}

        <button
          className={`btnPay ${isFormValid ? "active" : "disabled"}`}
          disabled={
            !isFormValid || Boolean(creditCardError) || Boolean(detailsError)
          }
          onClick={handleContinue}
        >
          Continue
        </button>
        <p style={{ color: "red" }}>{detailsError}</p>
        <p style={{ color: "red" }}>{creditCardError}</p>
        <p style={{ color: "red" }}>{cardError}</p>
      </div>
    </div>
  );
};

export default CCInstantPay;
